import { Button, ButtonGroup, DateTimeInput, Field, NumericInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DateTimeStyle } from 'Components/Layout/Grid/types';
import { WorksheetBalanceFieldSet, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDryMassGridFieldSet } from '../gridFieldSets';

interface IConstantDryMassWithTraysWorksheet extends IWorksheetComponent {
  addTrayButtonVissible?: boolean;
}

let AnnexASievingWashConstantDryMassSingleTraySection: React.FC<IConstantDryMassWithTraysWorksheet> = ({
  createWorksheetSelector,
  prefixName,
  addTrayButtonVissible,
}) => {
  const dispatch = useDispatch();

  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const showTimeInOven = dryMassEntryOption !== 'Never';

  const showSingleReadingSection = useSelector(
    pipe(
      createWorksheetSelector!('DryingTrays[0].DryMassReadings'),
      (r) => (r?.length ?? 0) <= 1 && dryMassEntryOption === 'Never'
    )
  );

  const trays = useSelector(createWorksheetSelector!('DryingTrays'), deepEquals) as any[];

  const updateTrays = (value: any[]) => {
    dispatch(
      actions.setValue({
        name: prefixName!('DryingTrays'),
        value: value,
        sync: true,
      })
    );
  };
  return (
    <>
      <ListFieldSection>
        {showTimeInOven && <Field input={<DateTimeInput />} name="DryingTrays[0].DateTimePlacedInOvenLocal" />}
        <WorksheetBalanceFieldSet name="Equipment.DryMassBalance" copyTo={['Equipment.Balance']} />
      </ListFieldSection>
      <ListFieldSection>
        <ButtonGroup>
          <Button visible={addTrayButtonVissible ?? false} onClick={() => updateTrays([...trays, {}])}>
            Add Tray
          </Button>
        </ButtonGroup>
      </ListFieldSection>
      {showSingleReadingSection ? (
        <ListFieldSection>
          <Field
            input={<NumericInput />}
            name="DryingTrays[0].DryMassReadings[0].DrySoilAndContainerMass"
            // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
            additionalMessagePaths={['DryingTrays[0].DryMassReadings[0].DrySoilMass']}
            // For Annex A we need to record DrySoilMass instead of DrySoilAndContainerMass,
            // to simplify the whole process we use DrySoilAndContainerMass property and zero container mass
            label="Dry Mass"
          />
        </ListFieldSection>
      ) : (
        <WorksheetGridFieldSection name="DryingTrays[0].DryMassReadings">
          <WorksheetRecordGrid
            name="DryingTrays[0].DryMassReadings"
            orientation="vertical"
            recordProps={{
              enforceAtLeastOneRecord: true,
              preventRemove: 'all-but-last',
              preventCreate: dryMassEntryOption === 'Never',
              removeConfirm: {
                confirm: true,
                confirmTitle: 'Delete Dry Mass Reading',
                confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                confirmButtonText: 'Delete',
              },
            }}
            fieldSet={getDryMassGridFieldSet(dryMassEntryOption, DateTimeStyle.Combined, true)}
          />
        </WorksheetGridFieldSection>
      )}
    </>
  );
};

AnnexASievingWashConstantDryMassSingleTraySection = withInjectedProps(
  AnnexASievingWashConstantDryMassSingleTraySection
);

export default AnnexASievingWashConstantDryMassSingleTraySection;
export { AnnexASievingWashConstantDryMassSingleTraySection };
